import { api } from "./client";
import type { Hotel, HotelCreate, PlatformStats, TokenPair, User, VendorAdminView } from "@/types";

// --- Auth (login only — no signup/social/e-KYC in the admin app) ---
export const authApi = {
  login: (identifier: string, password: string) =>
    api.post<TokenPair>("/auth/login", { identifier, password }),
  logout: () => api.post("/auth/logout"),
  me: () => api.get<User>("/users/me"),
};

// --- Admin (backend enforces the admin-role RBAC check on every route) ---
export const adminApi = {
  stats: () => api.get<PlatformStats>("/admin/stats"),
  queue: () => api.get<VendorAdminView[]>("/admin/verification-queue"),
  approve: (publicId: string) =>
    api.post<{ message: string }>(`/admin/vendors/${publicId}/approve`),
  reject: (publicId: string) =>
    api.post<{ message: string }>(`/admin/vendors/${publicId}/reject`),
  listHotels: () => api.get<Hotel[]>("/admin/hotels"),
  createHotel: (body: HotelCreate) => api.post<Hotel>("/admin/hotels", body),
};
